import BaseService from "./base";

/**
 * This is the service class that handles all requests to the dam-projects api.
 * @class DamProjectsService
 * @extends BaseService
 */
export class DamProjectsService extends BaseService {
    constructor() {
        super("damprojects");
    }

    getProjects() {
        return this.api("DAMProjects");
    }

    getProject(id) {
        return this.api(`DAMProject/${id}/progress`);
    }

    deleteProject(id) {
        return this.api(`deleteDAMProject/${id}`, {
            method: "POST"
        });
    }

    updateProject(id, body) {
        return this.api(`updateDAMProject/${id}`, {
            method: "POST",
            body: JSON.stringify(body),
        });
    }

    cloneProject(id, projectName) {
        this.apiUrl = `/api/analysis/`;
        return this.api(`cloneDAMProject`, {
            method: "POST",
            body: JSON.stringify({ idproject: id, projectname: projectName }),
        });
    }

    createProject(body) {

        return this.api(`createDAMProject`, {
            method: "POST",
            body: JSON.stringify(body),
        });
    }



    getAppOverview(idproject, step = 1) {
        return this.api(`AppOverview?idproject=${idproject}&projectStep=${step}`);
    }

    getAppOverviewKPIs(idproject, step = 1) {
        return this.api(`AppOverviewKPIs?idproject=${idproject}&projectStep=${step}`);
    }

    getWebApps(idproject, step = 0) {
        return this.api(`WebAppOverview?idproject=${idproject}&projectStep=${step}`);
    }

    getProjectAnonymizations(idproject) {
        return this.api(`getProjectAnonymizations/${idproject}/2`);
    }
    getProjectLimitations(idproject, step = 0) {
        return this.api(`getProjectLimitations/${idproject}/${step}`);
    }
    DAMLimitations(idLimitation, preset = false) {
        return this.api(`DAMLimitations/${idLimitation}?preset=${preset}`);
    }

    saveDAMLimitationItem(body, preset = false) {
        return this.api(`saveDAMLimitationItem?preset=${preset}`, {
            method: "POST",
            body: JSON.stringify(body),
        });
    }
    deleteDAMLimitation(id, preset = false) {
        return this.api(`deleteDAMLimitation/${id}?preset=${preset}`, {
            method: "POST",
        });
    }

    getDAMTeamUsers() {
        return this.api(`getDAMTeamUsers`);
    }
    
    DAMTeams(idProject) {
        return this.api(`DAMTeams/${idProject}`);
    }

    saveDAMTeam(body) {
        return this.api(`saveDAMTeam`, {
            method: "POST",
            body: JSON.stringify(body),
        });
    }
    deleteDAMTeam(idTeam) {
        return this.api(`deleteDAMTeam/${idTeam}`, {
            method: "POST",
        });
    }


    startScopingRecording(body) {
        return this.api(`startScopingRecording`, {
            method: "POST",
            body: JSON.stringify(body),
        });
    }
    startAnonymizationRecording(idProject) {
        return this.api(`startAnonymizationRecording`, {
            method: "POST",
            body: JSON.stringify({ idproject: idProject }),
        });

    }
    startMainRecording(idProject) {
        return this.api(`startMainRecording`, {
            method: "POST",
            body: JSON.stringify({ idproject: idProject }),
        });
    }

    completeDAMProjectStep(idProject, step) {
        return this.api(`completeDAMProjectStep/${idProject}/${step}`, {
            method: "POST",
        });
    }

    getAnonymizationLog(idProject) {    
        return this.api(`getAnonymizationLog?idproject=${idProject}`);
    }

    getAnonymizationUILog(idProject) {
        return this.api(`getAnonymizationUILog?idproject=${idProject}`);
    }

    DAMAnonymizationRules(idAnonymization, preset = false) {
        return this.api(`DAMAnonymizationRules/${idAnonymization}?preset=${preset}`);
    }

    DAMAnonymizationRulesUI(idAnonymization, preset = false) {
        return this.api(`DAMAnonymizationRulesUI/${idAnonymization}?preset=${preset}`);
    }
    saveDAMAnonymizationRule(payload, preset = false) {
        return this.api(`saveDAMAnonymizationRule?preset=${preset}`, {
            method: "POST",
            body: JSON.stringify(payload),
        });
    }
    deleteDAMAnonymizationRule(id, preset = false) {
        return this.api(`deleteDAMAnonymizationRule/${id}?preset=${preset}`, {
            method: "POST",
        });
    }
    saveDAMAnonymizationRuleUI(payload) {
        return this.api(`saveDAMAnonymizationRuleUI`, {
            method: "POST",
            body: JSON.stringify(payload),
        });
    }
    deleteDAMAnonymizationRuleUI(id) {
        return this.api(`deleteDAMAnonymizationRuleUI/${id}`, {
            method: "POST",
        });
    }
}

